import { useState } from "react";
import { Container } from "reactstrap";
import SitesImport from "./SitesImport";
import DistrbutionImport from "./DistrbutionImport";
import LogbookAssetDetails from "./LogbookAssetDetails";
import { useLocation } from "react-router-dom";

const Import = () => {
  const LoginUserGroup = localStorage.getItem("groups");
  const state = useLocation();
  const params = new URLSearchParams(state.search);
  console.log("state", state);
  const fromSites = params.get("fromSites") === "true";
  const [pageData, setPageData] = useState({
    step:
      LoginUserGroup === "site_owner" || LoginUserGroup === "spao"
        ? state.state && state.state.category && state.state.site
          ? 3
          : 1
        : 3,
    siteDetailsImport: "",
    dbDetailsImport: "",
    logbookAssetDetailsImport: "",
  });

  const nextStep = () => {
    const {
      step,
      siteDetailsImport,
      dbDetailsImport,
      logbookAssetDetailsImport,
    } = pageData;

    let next = step + 1;

    //  skip step 3 if fromSites
    if (fromSites && next === 3) {
      next = 1; // skip LogbookAssetDetails
    }

    setPageData({
      step: next,
      siteDetailsImport,
      dbDetailsImport,
      logbookAssetDetailsImport,
    });
  };
  // Go to prev step
  const prevStep = () => {
    const {
      step,
      siteDetailsImport,
      dbDetailsImport,
      logbookAssetDetailsImport,
    } = pageData;
    setPageData({
      step: step - 1,
      siteDetailsImport: siteDetailsImport,
      dbDetailsImport: dbDetailsImport,
      logbookAssetDetailsImport: logbookAssetDetailsImport,
    });
  };
  return (
    <Container fluid={true} className="p-0">
      {pageData.step === 1 && (
        <SitesImport nextStep={nextStep} values={pageData} />
      )}
      {pageData.step === 2 && (
        <DistrbutionImport
          prevStep={prevStep}
          nextStep={nextStep}
          values={pageData}
        />
      )}
      {/* {pageData.step === 3 && (
        <CategoryImport
          prevStep={prevStep}
          nextStep={nextStep}
          values={pageData}
        />
      )} */}
      {pageData.step === 3 && (
        <LogbookAssetDetails
          prevStep={prevStep}
          nextStep={nextStep}
          values={pageData}
        />
      )}
    </Container>
  );
};
export default Import;
